import { TextField } from "@mui/material";
import { CustomAutocomplete } from "./CustomAutocomplete";

const matches = (option, value) => value !== undefined && value !== null && String(option.value) === String(value);

// Searchable dropdown that replaces every plain <select>: type to filter the
// options, same 45px height as CustomInput / CustomSelect (`height` for denser
// toolbars). Options are { value, label }; `value` / `onChange(value)` are the
// raw option value ("" when cleared).
//   clearable={false}  for fields that always hold a value (e.g. Active / Inactive)
const CustomSearchSelect = ({
  id,
  name,
  options = [],
  value,
  onChange,
  placeholder = "Select",
  disabled = false,
  clearable = true,
  height,
}) => {
  const selected = options.find((option) => matches(option, value)) || null;

  return (
    <CustomAutocomplete
      id={id}
      options={options}
      value={selected}
      disabled={disabled}
      disableClearable={!clearable}
      autoHighlight
      noOptionsText="No options"
      getOptionLabel={(option) => String(option.label ?? "")}
      isOptionEqualToValue={(a, b) => String(a.value) === String(b.value)}
      onChange={(event, picked) => onChange(picked ? picked.value : "")}
      ListboxProps={{ sx: { fontSize: 14 } }}
      sx={height ? { "& .MuiOutlinedInput-root": { minHeight: height } } : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          name={name}
          placeholder={placeholder}
          inputProps={{ ...params.inputProps, "aria-label": placeholder }}
        />
      )}
    />
  );
};

export default CustomSearchSelect;
